import gql from 'graphql-tag';

export const RemoveEmailFromBounceListIfExist = gql`
  mutation removeEmailFromBounceListIfExist($input: RemoveEmailFromBounceListIfExistInput!) {
    removeEmailFromBounceListIfExist(input: $input) {
      messsage
    }
  }
`;
